import { h } from '@stencil/core/internal/client';
import { s as skeleton } from './parts.js';

const Skeleton = ({ component = 'div', height, width, className, styles = {}, }) => {
    const combinedStyle = Object.assign(Object.assign({}, styles), { width,
        height });
    const TagType = component;
    return (h(TagType, { class: `${className} skeleton`, style: combinedStyle, part: skeleton, "aria-hidden": "true" }));
};

export { Skeleton as S };
